
import React from 'react';
import { toast } from 'sonner';

export function usePublishNotifications() {
  const notifyAutoPublishSuccess = (intervieweeName: string) => {
    toast.success(
      <div>
        <p>Auto-publisert: {intervieweeName}</p>
        <div className="mt-2">
          <a 
            href="/publish-history" 
            className="text-sm bg-green-100 hover:bg-green-200 text-green-800 px-2 py-1 rounded"
          >
            Vis i publiseringshistorikk
          </a>
        </div>
      </div>, 
      { 
        id: 'auto-publishing',
        duration: 5000
      }
    );
  };
  
  const notifyAutoPublishError = (error: unknown) => {
    console.error('Auto-publisering feilet:', error);
    toast.error('Auto-publisering feilet. Se konsollen for detaljer.', { id: 'auto-publishing' });
  };
  
  const notifyNoInterviewsToPublish = (debugInfo: { 
    anyFeederInterviews: boolean, 
    nonPendingCount: number,
    feederInterviewStatuses: string
  }) => {
    console.log('Ingen ventende intervjuer å auto-publisere');
    
    if (!debugInfo.anyFeederInterviews) {
      toast.info('Ingen intervjuer funnet i køen', { id: 'auto-publishing' });
    } else if (debugInfo.nonPendingCount > 0) {
      console.log('Intervjuer i køen med status:', debugInfo.feederInterviewStatuses);
      
      toast.info(
        `${debugInfo.nonPendingCount} intervjuer i køen, men de er allerede publisert. ` +
        `For å auto-publisere nytt innhold, legg til intervjuer med 'ventende' status i køen.`, 
        { id: 'auto-publishing', duration: 5000 }
      );
    } else {
      toast.info('Ingen ventende intervjuer tilgjengelig for auto-publisering', { id: 'auto-publishing' });
    }
  };
  
  const notifyAutoPublishToggle = (isEnabled: boolean, interval: number) => {
    if (isEnabled) {
      toast.success(`Auto-publisering aktivert. Vil publisere ett intervju hvert ${interval}. sekund.`);
    } else {
      toast.info('Auto-publisering deaktivert');
    }
  };
  
  const notifyPublishLoading = (intervieweeName: string) => {
    toast.loading(`Auto-publiserer: ${intervieweeName}...`, { id: 'auto-publishing' });
  };
  
  return {
    notifyAutoPublishSuccess,
    notifyAutoPublishError,
    notifyNoInterviewsToPublish,
    notifyAutoPublishToggle,
    notifyPublishLoading
  };
}
